var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3491_2304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4.4375H4.9375V62.125C4.9375 63.3019 5.40502 64.4306 6.23721 65.2628C7.06941 66.095 8.1981 66.5625 9.375 66.5625H67.0625V62.125H9.375V4.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0625 19.9688H51.5312V24.4062H59.4966L42.6562 41.2466L33.1378 31.7059C32.9316 31.498 32.6862 31.3329 32.4158 31.2203C32.1454 31.1076 31.8554 31.0496 31.5625 31.0496C31.2696 31.0496 30.9796 31.1076 30.7092 31.2203C30.4388 31.3329 30.1934 31.498 29.9872 31.7059L13.8125 47.9028L16.9409 51.0312L31.5625 36.4097L41.0809 45.9503C41.2872 46.1583 41.5326 46.3233 41.803 46.436C42.0733 46.5486 42.3633 46.6066 42.6562 46.6066C42.9492 46.6066 43.2392 46.5486 43.5095 46.436C43.7799 46.3233 44.0253 46.1583 44.2316 45.9503L62.625 27.5347V35.5H67.0625V19.9688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3491_2304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.980fb671a8c6faa02307c3275359be47.svg";
export { ForwardRef as ReactComponent };